import { IAstNode, IIdentifierArrayAstNode, IComposeFunc } from '../../typings/ast-node';
import { IToken, ISupportToken } from '../../typings/token';
import { getCloseBracketTokenPosition } from '../../utils';
import { TokenComposeError } from '../../errors';
import { splitTokensWithComma } from '../utils';



export function composeBrackets(astNodes: IAstNode[], compose: IComposeFunc) {
  const start = astNodes.findIndex(({ type, token }) => {
    return type === 'Temporary' && !!token && token.type === 'OpenBracket';
  });
  if (start === -1) { return; }

  const tokens = astNodes.map(node => node.token) as IToken[];
  const end = getCloseBracketTokenPosition(start, tokens, 'OpenBracket', 'CloseBracket');
  if (end === -1) {
    throw new TokenComposeError('bracket-not-closed', '数组缺少结束括号', tokens[start].position);
  }
  const eatNodes = astNodes.slice(start, end + 1);
  const arrayNodes = astNodes.slice(start + 1, end);
  const arrayItemsNodes = splitTokensWithComma(arrayNodes);
  arrayItemsNodes.forEach(itemTNodes => {
    if (!itemTNodes.length) {
      throw new TokenComposeError('invalid-array-item', '数组值不能为空', tokens[start].position);
    }
  });
  const node: IIdentifierArrayAstNode = {
    type: 'IdentifierArray',
    items: arrayItemsNodes.map(arg => compose(arg)),
    token: { type: 'Composed' } as ISupportToken,
    openBracketToken: tokens[start] as ISupportToken,
    closeBracketToken: tokens[end] as ISupportToken
  };
  astNodes.splice(start, eatNodes.length, node);
  composeBrackets(astNodes, compose);
}
